import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { request, reportErrorToHoneybadger } from '../../helpers/Requests'
import LoggedOutHeader from '../../components/header/LoggedOutHeader';
import BigLogo from '../../components/header/BigLogo';
import SetTitle from '../../components/shared/SetTitle';

import { renderErrors, renderErrorWarning } from '../../utilities/Forms.js'

class ForgottenPassword extends Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleShowSupportForm = this.handleShowSupportForm.bind(this);
    this.handleSupportSubmit = this.handleSupportSubmit.bind(this);
  }

  state = {
    emailAddress: this.props.location.state === undefined ? "" : this.props.location.state.emailAddress,
    resettingPassword: false,
    updated: false,

    showSupportForm: false,
    organisation_name: "",
    location_name: "",
    message: "",
    submitting: false,
    supportSubmitted: false,

    errors: "",
    error: ""
  };

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({[name]: value});
  }

  handleSubmit(event) {
    this.setState({resettingPassword: true})
    this.setState({errors: ""})
    this.setState({error: ""})

    const json = JSON.stringify({
      "password_reset": {
        "email_address": this.state.emailAddress,
      }
    })

    request('POST', `/v1/a/users/request_password_reset`, json)
      .then(data => {
        this.setState({ updated: true, errors: "" })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error.errors) {
          this.setState({
            resettingPassword: false,
            errors: error
          })
        }
        else {
          this.setState({
            resettingPassword: false,
            error: error
          })
        }
      })

    event.preventDefault();
  }

  handleShowSupportForm() {
    this.setState({ showSupportForm: true });
  }

  handleSupportSubmit(event) {
    event.preventDefault();

    this.setState({
      submitting: true,
      errors: "",
      error: ""
    });

    const json = JSON.stringify({
      logged_out_ticket: {
        email: this.state.emailAddress,
        organisation_name: this.state.organisation_name,
        location_name: this.state.location_name,
        message: this.state.message
      }
    });

    request("POST", "/v1/a/logged_out_tickets", json)
      .then(() => {
        this.setState({
          supportSubmitted: true,
          submitting: false
        })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error instanceof Error) {
          this.setState({ submitting: false, error: error })
        }
        else {
          this.setState({ submitting: false, errors: error })
        }
      })
  }

  renderErrors() {
    if (this.state.errors) {
      return (
        <div className="errors">
          Sorry, looks like there are some errors:
          <ul>
            {this.state.errors.errors.map((error) => (
              <li>{error}</li>
            ))}
          </ul>
        </div>
      )
    }
  }

  renderUpdated() {
    if (this.state.updated && this.state.showSupportForm === false) {
      return (
        <div className="login-form forgotten-password">
          <p className="success">If your details match an account and you haven’t requested a password reset recently, we'll email you a reset link.</p>
          <br/>
          <p className="success"> If you haven't received anything, please contact support <Link onClick={this.handleShowSupportForm} to={{ pathname: "/forgotten-password"}}>here</Link>.</p>
        </div>
      )
    }
  }

  renderSupportForm() {
    const { organisation_name, location_name, message, errors } = this.state;

    if (this.state.showSupportForm && !this.state.supportSubmitted) {
      return (
        <div className="login-form forgotten-password">
          <p className="success">If you haven't received a password reset email, or if you're having trouble accessing your account, you can contact support below.</p>
          <br/>
          <form onSubmit={this.handleSupportSubmit} className="logged-out-support">

            <label>Email Address:</label>{ renderErrors(errors, 'email') }
            <input type="email" name="emailAddress" value={this.state.emailAddress} onChange={this.handleChange} />

            <label>Organisation Name:</label>{ renderErrors(errors, 'organisation_name') }
            <input type="text" name="organisation_name" value={organisation_name} onChange={this.handleChange} />

            <label>Location Name:</label>{ renderErrors(errors, 'location_name') }
            <input type="text" name="location_name" value={location_name} onChange={this.handleChange} />

            <label>Message:</label>{ renderErrors(errors, 'message') }
            <textarea name="message" value={message} placeholder="Describe your issue" onChange={this.handleChange} />

            <input type="submit" value="Contact Support" disabled={this.state.submitting} />

            { renderErrorWarning(errors) }
          </form>
        </div>
      )
    }
  }

  renderSupportSubmitted() {
    if (this.state.supportSubmitted) {
      return (
        <div className="login-form forgotten-password">
          <p className="success">Your support request has been submitted.</p>
          <p className="success">Our team will try to review it and respond at the earliest.</p>
        </div>
      )
    }
  }

  renderForm() {
    if (this.state.updated === false) {
      return (
        <div className="login-form forgotten-password">
          <p>If you have forgotten your password or can't login, please enter your email address and then follow the link we send you.</p>
          <form onSubmit={this.handleSubmit}>
            <label>
              <input placeholder=" email address" aria-required="true" type="email" name="emailAddress" value={this.state.emailAddress} onChange={this.handleChange} />
            </label>
            <br />
            <input type="submit" value="Submit" />
          </form>

          {this.resettingPasswordMessage(this.state)}

          { this.renderErrors() }
        </div>
      )
    }
  }

  resettingPasswordMessage(state) {
    if (state.resettingPassword) {
      return (
        <div>
          Resetting password
          <span className="blink1">.</span>
          <span className="blink2">.</span>
          <span className="blink3">.</span>
        </div>
      )
    }
  }

  render() {
    const { error } = this.state;

    if (error) {
      return <div>{error.message}</div>;
    }

    return (
      <div className="login-page">
        <SetTitle title={"Forgotten Password"} />
        <LoggedOutHeader />

        <div className="center-container">
          <div className="login-box">
            <p className="welcome-to">Welcome to...</p>

            <BigLogo />

            {this.renderForm()}
            {this.renderUpdated()}
            {this.renderSupportForm()}
            {this.renderSupportSubmitted()}
          </div>

        </div>

      </div>
    );
  }
}

export default ForgottenPassword;
